'use client';

import { useEffect, useState } from 'react';

type BreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const breakpointQueries: Record<BreakpointKey, string> = {
    xs: '(max-width: 650px)',
    sm: '(max-width: 960px)',
    md: '(max-width: 1280px)',
    lg: '(max-width: 1400px)',
    xl: '(max-width: 1920px)'
};

const isBreakpointKey = (value: string): value is BreakpointKey => value in breakpointQueries;

function useMediaQuery(mediaQuery: string | BreakpointKey): boolean {
    const [matches, setMatches] = useState<boolean>(false);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(
            isBreakpointKey(mediaQuery) ? breakpointQueries[mediaQuery] : mediaQuery
        );

        const handleChange = (event) => {
            setMatches(event.matches);
        };

        handleChange(mediaQueryList);

        mediaQueryList.addEventListener('change', handleChange);

        return () => {
            mediaQueryList.removeEventListener('change', handleChange);
        };
    }, [mediaQuery]);

    return matches;
}

export default useMediaQuery;
